import React from 'react';
import { compose, isNil, reject, defaultTo, prop, propOr, toLower } from 'ramda';
import { useHistory } from 'react-router-dom';
import { Table, Button } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import QColors from '../../../_graphql/queries/documents/QColors';
import { Section, Title, Actions } from '../../../components';
import DeleteColorMutation from '../../../_graphql/mutations/documents/DeleteColorMutation';
import { errorMessage } from '../../../utils/messageMutation';
import TableDates from '../../docs/components/tag/TableDates';
import ConfirmButton from '../../../components/ConfirmButton';
import useActionGuard from '../../../hooks/useActionGuard';
import PreviewColor from './components/PreviewColor';

const Colors = () => {
  const history = useHistory();
  const { loading, run } = useActionGuard();

  const deleteColor = colorId => {
    run(`delete-color-${colorId}`, (done) => DeleteColorMutation({ colorId }, done), (ok, error) => {
      if (!ok || error) {
        errorMessage();
      }
    });
  };

  const columnSorter = (field) => (a, b) => toLower(prop(field, a)).localeCompare(toLower(prop(field, b)));

  return (
    <>
      <Actions
        title={<Title title="Les couleurs de mon équipe" backTo="/equipe/parametrage" />}
        buttons={(
          <Button
            onClick={() => history.push('/equipe/couleurs/creer')}
            type="primary"
            size="large"
          >
            Créer une couleur
          </Button>
        )}
      />
      <Section>
        <QColors>
          {colors => {
            colors = compose(
              reject(isNil),
              defaultTo([])
            )(colors);

            return (
              <Table
                dataSource={colors}
                rowKey="id"
                pagination={false}
                size="small"
                locale={{ emptyText: 'Aucune donnée' }}
              >
                <Table.Column
                  title="Nom"
                  dataIndex="name"
                  width={250}
                  defaultSortOrder="ascend"
                  sorter={columnSorter('name')}
                  render={value => <span>{value}</span>}
                />

                <Table.Column
                  title="Uuid"
                  dataIndex="uuid"
                  width={250}
                  defaultSortOrder="ascend"
                  sorter={columnSorter('uuid')}
                  render={value => <span>{value}</span>}
                />

                <Table.Column
                  title="Couleur"
                  dataIndex="value"
                  width={250}
                  render={value => (
                    <PreviewColor
                      color={value}
                    />
                  )}
                />

                {TableDates}

                <Table.Column
                  title=""
                  dataIndex="id"
                  render={(colorId) => {
                    return (
                      <div className="flex justify-end text-lg gap-2">
                        <Button
                          icon={<EditOutlined className="hover:text-flexi-grey" />}
                          onClick={() => history.push(`/equipe/couleurs/${colorId}/edition`)}
                          type="text"
                        />

                        <ConfirmButton
                          title="Êtes-vous sûr de vouloir supprimer cette couleur ?"
                          onConfirm={() => deleteColor(colorId)}
                          icon={<DeleteOutlined className="btn-remove-color hover:text-flexi-red" />}
                          buttonType="text"
                          loading={propOr(false, `delete-color-${colorId}`, loading)}
                        />
                      </div>
                    );
                  }}
                />
              </Table>
            );
          }}
        </QColors>
      </Section>
    </>
  );
};

export default Colors;
